var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CollapseCircleIcon, ExpandCircleIcon } from '@marketing/components/global/Icons';
import { clsx } from 'clsx';
var Accordion = function (_a) {
    var title = _a.title, children = _a.children, className = _a.className;
    return (_jsxs("details", __assign({ className: "group first-of-type:border-t border-b" }, { children: [_jsxs("summary", __assign({ className: clsx('flex justify-between items-center', className) }, { children: [_jsx("span", __assign({ className: "text-sm-med-m md:text-sm-med-d" }, { children: title })), _jsx("span", __assign({ className: "font-bold inline group-open:hidden" }, { children: _jsx(ExpandCircleIcon, { className: "size-[34px]" }) })), _jsx("span", __assign({ className: "font-bold hidden group-open:inline" }, { children: _jsx(CollapseCircleIcon, { className: "size-[34px]" }) }))] })), _jsx("div", __assign({ className: "text-sm-reg-m md:text-sm-reg-d py-6" }, { children: children }))] })));
};
export default Accordion;
